export default {
  // Profile
  profile_title: 'User Profile',
  personal_info: 'Personal Information',
  preferences: 'Preferences',
  recent_activity: 'Recent Activity',
  help_center: 'Help Center',
  full_name: 'Full Name',
  email: 'Email',
  phone: 'Phone',
  role: 'Role',
  status: 'Status',
  save_changes: 'Save Changes',
  saving: 'Saving...',
  change_password: 'Change Password',
  manage_users: 'Manage Users',
  email_cannot_change: 'Email cannot be changed',
  role_assigned_by_admin: 'Role is assigned by the administrator',

  // Preferences
  notifications: 'Notifications',
  email_notifications: 'Email notifications',
  email_notifications_desc: 'Receive important updates by email',
  task_reminders: 'Task reminders',
  task_reminders_desc: 'Alerts when deadlines are approaching',
  weekly_reports: 'Weekly reports',
  weekly_reports_desc: 'Weekly summary of activities and progress',
  appearance: 'Appearance',
  language: 'Language',
  theme: 'Theme',
  theme_light: 'Light',
  theme_dark: 'Dark',
  theme_auto: 'Auto',
  spanish: 'Español',
  english: 'English',
  save_preferences: 'Save Preferences',

  // Password
  current_password: 'Current Password',
  new_password: 'New Password',
  confirm_new_password: 'Confirm New Password',
  password_min_chars: 'Minimum 6 characters',
  cancel: 'Cancel',
  change: 'Change',
  password_success: 'Changes saved successfully',
  password_error_match: 'Passwords do not match',
  password_error_length: 'Password must be at least 6 characters',

  // Activity
  login_success: 'Login successful',
  hours_ago: '{{count}} hours ago',
  day_ago: '1 day ago',
  days_ago: '{{count}} days ago',

  // Dashboard / Home
  dashboard: 'Home',
  processes: 'Processes',
  dependencies: 'Dependencies',
  tasks: 'Tasks',
  evidences: 'Evidences',
  tracking: 'Tracking & Evaluation',
  reports: 'Reports',
  ranking: 'Ranking',
  users: 'Users',
  logout: 'Logout',
  search: 'Search',
};